import axios from "axios";
import { getToken, getUser, getToken2 } from "../Utils/Common";
import { getAPICall, postAPICall, postAPICall2 } from "./axiosMethodCalls";

/***************************
 * LOGIN
 ***************************/

// Check Token Status
export const checkTokenStatus = async (token) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "users/get_user",
            {
                requester: getUser(),
                token: getToken(),
                pin: getUser(),
            }
        );
        //
        return true;
    } catch (error) {
        //
        return false;
    }
};

// FOR MANGO MAGIC
export const loginUser = async (username, password) => {
    try {
        const response = await postAPICall2(
            process.env.REACT_APP_LINK + "authentication",
            {
                username: username,
                password: password,
                authentication_type: "ERP"
            },
            {
                "api-key": process.env.REACT_APP_KEY,
                "Content-Type": "application/json",
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        //
        return { error: error.response };
    }
};
// FOR POTATO CORNER
export const loginUser2 = async (username, password) => {
    try {
        const response = await postAPICall2(
            process.env.REACT_APP_POTATO + "authentication",
            {
                username: username,
                password: password,
                authentication_type: "ERP",
            },
            {
                "api-key": process.env.REACT_APP_KEY,
                "Content-Type": "application/json",
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        //
        return { error: error.response };
    }
};

/***************************
 * LOGOUT
 ***************************/

export const logoutUser = async () => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "authentication",
            {
                requester: getUser(),
                token: getToken(),
                authentication_type: "logout",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const logoutUserPotato = async () => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_POTATO + "authentication",
            {
                requester: getUser(),
                token: getToken2(),
                authentication_type: "logout",
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
